export class AppConfig {
    public static get serverUrlBase(): string {
        const serverBaseUrl = process.env.REACT_APP_SERVER_URL_BASE;
        if (!serverBaseUrl) throw new Error(`No environment variable error: 'process.env.REACT_APP_SERVER_URL_BASE'`);
        return serverBaseUrl;
    }

    public static get cognitoGoogleAuthCodeURL(): string {
        const baseURL = AppConfig.cognitoBaseUrl;
        const clientId = AppConfig.cognitoClientId;
        const scope = AppConfig.cognitoScope;
        const authRedirectURI = AppConfig.cognitoAuthRedirectURICoded;
        const googleIdp = AppConfig.cognitoGoogleIdp;
        return `${baseURL}/authorize?client_id=${clientId}&response_type=code&scope=${scope}&identity_provider=${googleIdp}&redirect_uri=${authRedirectURI}`;
    }

    public static get cognitoSlackTokenCodeURL(): string {
        const baseURL = AppConfig.cognitoBaseUrl;
        return `${baseURL}/token`;
    }

    public static get cognitoSlackAuthCodeURL(): string {
        const baseURL = AppConfig.cognitoBaseUrl;
        const clientId = AppConfig.cognitoClientId;
        const scope = AppConfig.cognitoSlackScope;
        const authRedirectURI = AppConfig.cognitoSlackRedirectURICoded;
        const slackIdp = AppConfig.cognitSlackIdp;

        return (
            `${baseURL}/authorize?client_id=${clientId}` +
            `&response_type=code` +
            `&scope=${scope}` +
            `&identity_provider=${slackIdp}` +
            `&redirect_uri=${authRedirectURI}`
        );
    }

    public static get cognitoGoogleTokenCodeURL(): string {
        const baseURL = AppConfig.cognitoBaseUrl;
        return `${baseURL}/token`;
    }

    public static get cognitoBaseUrl(): string {
        const baseURL = process.env.REACT_APP_COGNITO_BASE_URL;
        if (!baseURL) throw new Error(`No environment variable error: 'process.env.REACT_APP_COGNITO_BASE_URL'`);
        return baseURL;
    }

    public static get cognitoClientId(): string {
        const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
        if (!clientId) throw new Error(`No environment variable error: 'process.env.REACT_APP_COGNITO_CLIENT_ID'`);
        return clientId;
    }

    public static get cognitoScope(): string {
        const scope = process.env.REACT_APP_COGNITO_SCOPE;
        if (!scope) throw new Error(`No environment variable error: 'process.env.REACT_APP_COGNITO_SCOPE'`);
        return scope;
    }

    public static get cognitoSlackScope(): string {
        const scope = process.env.REACT_APP_COGNITO_SLACK_SCOPE;
        if (!scope) throw new Error(`No environment variable error: 'process.env.REACT_APP_COGNITO_SLACK_SCOPE'`);
        return scope;
    }

    public static get cognitoAuthRedirectURI(): string {
        const authRedirectURI = process.env.REACT_APP_COGNITO_AUTH_REDIRECT_URI;
        if (!authRedirectURI) throw new Error(`No environment variable error: 'process.env.REACT_APP_COGNITO_AUTH_REDIRECT_URI'`);
        return authRedirectURI;
    }

    public static get cognitoSlackAuthRedirectURI(): string {
        const authRedirectURI = process.env.REACT_APP_COGNITO_SLACK_AUTH_REDIRECT_URI;
        if (!authRedirectURI) throw new Error(`No environment variable error: 'process.env.REACT_APP_COGNITO_SLACK_AUTH_REDIRECT_URI'`);
        return authRedirectURI;
    }

    public static get cognitoAuthRedirectURICoded(): string {
        const authRedirectURICoded = process.env.REACT_APP_COGNITO_AUTH_REDIRECT_URI_CODED;
        if (!authRedirectURICoded) throw new Error(`No environment variable error: 'process.env.REACT_APP_COGNITO_AUTH_REDIRECT_URI_CODED'`);
        return authRedirectURICoded;
    }

    public static get cognitoSlackRedirectURICoded(): string {
        const authRedirectURICoded = process.env.REACT_APP_COGNITO_SLACK_AUTH_REDIRECT_URI_CODED;
        if (!authRedirectURICoded) throw new Error(`No environment variable error: 'process.env.REACT_APP_COGNITO_SLACK_AUTH_REDIRECT_URI_CODED'`);
        return authRedirectURICoded;
    }

    public static get cognitoGoogleIdp(): string {
        const googleIdp = process.env.REACT_APP_COGNITO_GOOGLE_IDP;
        if (!googleIdp) throw new Error(`No environment variable error: 'process.env.REACT_APP_COGNITO_GOOGLE_IDP'`);
        return googleIdp;
    }

    public static get cognitSlackIdp(): string {
        const slackIdp = process.env.REACT_APP_COGNITO_SLACK_IDP;
        if (!slackIdp) throw new Error(`No environment variable error: 'process.env.REACT_APP_COGNITO_GOOGLE_IDP'`);
        return slackIdp;
    }

    public static get webSocketURL(): string {
        const webSocketURL = process.env.REACT_APP_WEB_SOCKET_URL;
        if (!webSocketURL) throw new Error(`No environment variable error: 'process.env.REACT_APP_WEB_SOCKET_URL'`);
        return webSocketURL;
    }

    public static get isWebSocketEnabled(): boolean {
        const isWebSocketEnabled = process.env.REACT_APP_WEB_SOCKET_ENABLED;
        if (!isWebSocketEnabled) throw new Error(`No environment variable error: 'process.env.WEB_SOCKET_ENABLED'`);
        return JSON.parse(isWebSocketEnabled) as boolean;
    }

    public static get isDevelopment(): boolean {
        return process.env.NODE_ENV === 'development';
    }

    public static get isProduction(): boolean {
        return process.env.NODE_ENV === 'production';
    }

    public static get googleAuthURL(): string {
        const baseURL = AppConfig.googleAuthBaseURL;
        const googleAuthRedirectURI = AppConfig.googleAuthRedirectURI;
        const googleClientId = AppConfig.googleAuthClientId;
        const googleAuthScope = AppConfig.googleAuthScope;
        return `${baseURL}?redirect_uri=${googleAuthRedirectURI}&prompt=consent&response_type=code&client_id=${googleClientId}&scope=${googleAuthScope}&access_type=offline`;
    }

    public static get googleAuthBaseURL(): string {
        const googleAuthBaseURL = process.env.REACT_APP_GOOGLE_AUTH_BASE_URL;
        if (!googleAuthBaseURL) throw new Error(`No environment variable error: 'process.env.REACT_APP_GOOGLE_AUTH_BASE_URL'`);
        return googleAuthBaseURL;
    }

    public static get googleAuthRedirectURI(): string {
        const googleAuthRedirectURI = process.env.REACT_APP_GOOGLE_AUTH_REDIRECT_URI;
        if (!googleAuthRedirectURI) throw new Error(`No environment variable error: 'process.env.REACT_APP_GOOGLE_AUTH_REDIRECT_URI'`);
        return googleAuthRedirectURI;
    }

    public static get googleAuthClientId(): string {
        const googleAuthClientId = process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID;
        if (!googleAuthClientId) throw new Error(`No environment variable error: 'process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID'`);
        return googleAuthClientId;
    }

    public static get googleAuthScope(): string {
        const googleAuthScope = process.env.REACT_APP_GOOGLE_AUTH_SCOPE;
        if (!googleAuthScope) throw new Error(`No environment variable error: 'process.env.REACT_APP_GOOGLE_AUTH_SCOPE'`);
        return googleAuthScope;
    }

    public static get getCyberlabOrganizationId(): string {
        if (!process.env.REACT_APP_CYBERLAB_ORGANIZATION_ID)
            throw new Error(`No environment variable error: 'process.env.REACT_APP_CYBERLAB_ORGANIZATION_ID'`);

        return process.env.REACT_APP_CYBERLAB_ORGANIZATION_ID;
    }

    public static get microsoftAuthClientId(): string {
        const microsoftAuthClientId = process.env.REACT_APP_MICROSOFT_AUTH_CLIENT_ID;
        if (!microsoftAuthClientId) throw new Error(`No environment variable error: 'process.env.REACT_APP_MICROSOFT_AUTH_CLIENT_ID'`);
        return microsoftAuthClientId;
    }

    public static get microsoftAuthAuthority(): string {
        const microsoftAuthAuthority = process.env.REACT_APP_MICROSOFT_AUTH_AUTHORITY;
        if (!microsoftAuthAuthority) throw new Error(`No environment variable error: 'process.env.REACT_APP_MICROSOFT_AUTH_AUTHORITY'`);
        return microsoftAuthAuthority;
    }

    public static get microsoftRedirectUri(): string {
        const microsoftRedirectUri = process.env.REACT_APP_MICROSOFT_REDIRECT_URI;
        if (!microsoftRedirectUri) throw new Error(`No environment variable error: 'process.env.REACT_APP_MICROSOFT_REDIRECT_URI'`);
        return microsoftRedirectUri;
    }
}
